import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import compose from 'recompose/compose';
import SITE_MODES from '../../../constants/site-modes';
import Notification from '../Notification';
import NOTIFICATIONS from '../../../constants/notifications';

const termsLink = 'https://jobzology.com/terms-and-conditions/';

const TermsAndConditionsNotification = ({ newAccount, siteMode }) => (<Notification
    type={NOTIFICATIONS.TERMS_AND_CONDITIONS}
    title={`Welcome ${!newAccount ? 'back' : ''} to ${siteMode === SITE_MODES.EDUCATION ? 'PathwayU' : 'jobZology'}!`}
    text={newAccount ? <span>
        {'By clicking the button below, you agree to and have read our '}
        <a target="_blank" rel="noopener noreferrer" href={termsLink}>Terms and Conditions</a>.
    </span> : <span>
        {'We have updated our Terms and Conditions. By clicking the button below, you agree to and have read our '}
        <a target="_blank" rel="noopener noreferrer" href={termsLink}>Terms and Conditions</a>.
    </span>}
    button={siteMode === SITE_MODES.EDUCATION ?
        'FIND YOUR CALLING' : 'CONTINUE'}
/>);

TermsAndConditionsNotification.propTypes = {
    newAccount: PropTypes.bool,
    siteMode: PropTypes.number,
};

const today = moment().startOf('day');

export default compose(
    connect(({ me, auth, theme }) => ({
        open: me && auth.ssoLogin,
        newAccount: me && today.diff(moment(me.dateCreated), 'days') < 2,
        siteMode: theme.siteMode,
    })),
    branch(({ open }) => !open, renderNothing),
)(TermsAndConditionsNotification);



// WEBPACK FOOTER //
// ./src/client/Components/TermsAndConditionsNotification/TermsAndConditionsNotification.js